import { CLASSE_TABELA_ASSINATURA, CLASSE_CELULA_LOGO } from './quillTabelaAssinatura'

const LIMITE_LINHAS_CONTINUACAO = 10

const SELETOR_LOGO_FLOAT = 'img[style*="float"]'

export function possuiBlocoAssinaturaFloat(html: string): boolean {
  if (!html) {
    return false
  }

  return !!new DOMParser().parseFromString(html, 'text/html').body.querySelector(SELETOR_LOGO_FLOAT)
}

function construirCelulaLogo(img: HTMLImageElement, rowspan: number): HTMLElement {
  const celula = document.createElement('td')
  celula.className = CLASSE_CELULA_LOGO
  celula.setAttribute('rowspan', String(rowspan))
  celula.setAttribute('style', 'vertical-align:top;padding-right:16px;')

  // src/alt/width vem do layout salvo: setAttribute em vez de interpolar no innerHTML, senao
  // um alt com aspas encerra o atributo e injeta markup arbitrario no corpo do e-mail.
  const logo = document.createElement('img')
  logo.setAttribute('src', img.getAttribute('src') || '')
  logo.setAttribute('alt', img.getAttribute('alt') || '')
  logo.setAttribute('width', img.getAttribute('width') || '')

  celula.appendChild(logo)

  return celula
}

function construirCelulaTexto(html: string): HTMLElement {
  const celula = document.createElement('td')
  celula.setAttribute('style', 'vertical-align:top;')
  celula.innerHTML = html

  return celula
}

function construirTabelaAssinatura(img: HTMLImageElement, linhas: string[]): HTMLElement {
  const tabela = document.createElement('table')
  tabela.className = CLASSE_TABELA_ASSINATURA
  tabela.setAttribute('style', 'border-collapse:collapse;')

  const corpo = document.createElement('tbody')

  linhas.forEach((linha, indice) => {
    const tr = document.createElement('tr')

    if (indice === 0) {
      tr.appendChild(construirCelulaLogo(img, linhas.length))
    }

    tr.appendChild(construirCelulaTexto(linha))
    corpo.appendChild(tr)
  })

  tabela.appendChild(corpo)

  return tabela
}

function converterBlocoAoRedorDaImagem(img: HTMLImageElement) {
  const blocoInicial = img.closest('p, div')

  if (!blocoInicial || !blocoInicial.parentNode || !blocoInicial.isConnected) {
    return
  }

  const clone = blocoInicial.cloneNode(true) as HTMLElement
  clone.querySelector(SELETOR_LOGO_FLOAT)?.remove()

  const linhas = [clone.innerHTML.trim()].filter(Boolean)

  let proximo = blocoInicial.nextElementSibling

  while (proximo && linhas.length < LIMITE_LINHAS_CONTINUACAO) {
    const ehTagValida = proximo.tagName === 'P' || proximo.tagName === 'DIV'
    const temOutraLogo = !!proximo.querySelector(SELETOR_LOGO_FLOAT)
    const texto = (proximo.textContent || '').trim()

    if (!ehTagValida || temOutraLogo || !texto) {
      break
    }

    linhas.push(proximo.innerHTML.trim())

    const aRemover = proximo
    proximo = proximo.nextElementSibling
    aRemover.remove()
  }

  if (linhas.length === 0) {
    return
  }

  blocoInicial.replaceWith(construirTabelaAssinatura(img, linhas))
}

export default function migrarBlocoAssinaturaFloat(html: string): string {
  if (!html) {
    return html
  }

  const doc = new DOMParser().parseFromString(html, 'text/html')
  const imagensComFloat = Array.from(doc.body.querySelectorAll(SELETOR_LOGO_FLOAT)) as HTMLImageElement[]

  if (!imagensComFloat.length) {
    return html
  }

  imagensComFloat.forEach(converterBlocoAoRedorDaImagem)

  return doc.body.innerHTML
}
